import { render, staticRenderFns } from "./ebcDT.vue?vue&type=template&id=70bb86da&scoped=true"
import script from "./ebcDT.vue?vue&type=script&lang=js"
export * from "./ebcDT.vue?vue&type=script&lang=js"
import style0 from "./ebcDT.vue?vue&type=style&index=0&id=70bb86da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb86da",
  null
  
)

export default component.exports